// removed by extract-text-webpack-plugin
module.exports = {"this":"Emoji__this___2hD4_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/Emoji.css
// module id = 1149
// module chunks = 4